export class ParticleSettings{

    private readonly Mid:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.01,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 50,
            "end": 1,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 30,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 20,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    };

    private readonly High:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.01,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 50,
            "end": 1,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 30,
            "max": 360
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 0,
            "max": 20
        },
        "lifetime": {
            "min": 1,
            "max": 1
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 20,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    };

    private readonly BigWin:any =    {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 200,
            "end": 300,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.4,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    private readonly SuperWin:any =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 250,
            "end": 350,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.25,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    private readonly MegaWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 350,
            "end": 450,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.1,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }
    
    private readonly EpicWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 400,
            "end": 500,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.05,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    private readonly WickedWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 400,
            "end": 500,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 110
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": -50,
            "max": 50
        },
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "normal",
        "frequency": 0.1,
        "emitterLifetime": -1,
        "maxParticles": 300,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -300,
            "w": 900,
            "h": 0
        }
    }

    private readonly ManiacWin:any =   {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.6,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 800,
            "end": 800,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 85,
            "max": 95
        },
        "noRotation": true,
        "lifetime": {
            "min": 8,
            "max": 8
        },
        "blendMode": "add",
        "frequency": 0.22,
        "emitterLifetime": -1,
        "maxParticles": 100,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -450,
            "y": -600,
            "w": 900,
            "h": 0
        }
    }

    private _allConfigs:any[] = [];

    public get allConfigs():any[]{
        return this._allConfigs;
    }

    constructor(){
        this._allConfigs.push(
            this.Mid,
            this.High,
            this.BigWin,
            this.SuperWin,
            this.MegaWin,
            this.EpicWin,
            this.WickedWin,
            this.ManiacWin
        )
    }
}